/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
import interfaces from './interface'

export const dependency = {
  lib: null,
  libInterface: null,
}

export const uninit = () => {
  dependency.lib = null
  dependency.libInterface = null
}

export const init = configObject => {
  uninit()

  // Stop at first recognized dependency
  Object.keys(interfaces).some(depName => {
    if (Object.prototype.hasOwnProperty.call(configObject, depName)) {
      const depObj = configObject[depName]
      const InterfaceClass = interfaces[depName]
      dependency.lib = depObj
      dependency.libInterface = new InterfaceClass(
        depObj,
        configObject.messages,
        configObject.onLogout
      )
      return true
    }
    return false
  })

  if (dependency.libInterface === null) {
    throw new Error("Couldn't find any matching mappings for provided dependencies.")
  }
}

export const applyInterfaceFunction = functionName => (...args) => {
  if (!dependency.libInterface) {
    return Promise.resolve(null)
  }

  return dependency.libInterface[functionName](...args)
}

export const success = applyInterfaceFunction('success')
export const confirm = applyInterfaceFunction('confirm')
export const confirmNoUndo = applyInterfaceFunction('confirmNoUndo')
export const confirmDelete = applyInterfaceFunction('confirmDelete')
export const deleteSuccess = applyInterfaceFunction('deleteSuccess')
export const error = applyInterfaceFunction('error')
export const close = applyInterfaceFunction('close')
export const handleError = applyInterfaceFunction('handleError')
